module.exports = __webpack_public_path__ + "img/G.2ee03be8.png";